import cn from 'classnames';
import { Formik, Form } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';

import Button from 'components/common/Button';
import FormField from 'components/common/FormField';
import { validateSvsCode } from 'helpers/vouchers';

const formatCode = code => code.replace(/\s/g, '');

const PromoCodeForm = ({
  handleAddVoucherClick,
  errorMessage = '',
  buttonVariation = 'TextPrimary',
  buttonClassName = '',
  buttonText = 'Apply',
  formFieldClassName,
}) => {
  const [showPin, setShowPin] = useState(false);

  return (
    <Formik
      initialValues={{
        promoCode: '',
        pin: '',
      }}
      validationSchema={Yup.object({
        promoCode: Yup.string().required('Please enter a promo code.'),
      })}
      onSubmit={handleAddVoucherClick}
    >
      {({ errors, setFieldValue, isSubmitting }) => (
        <Form
          className={cn('relative flex w-full flex-col', {
            'pb-10': errorMessage || errors.promoCode,
          })}
        >
          <div className={cn('flex h-14', formFieldClassName)}>
            <FormField
              label="Promo Code or Gift Card"
              labelClass="sr-only"
              inputClass="w-60 bp2:w-72 pl-4 border-r-0 rounded-l rounded-r-none h-full"
              id="promoCode"
              name="promoCode"
              placeholder="Promo Code or Gift Card"
              onKeyUp={event => {
                const formattedValue = formatCode(event.target.value);
                setFieldValue('promoCode', formattedValue);
                validateSvsCode({ value: formattedValue, callbackFn: setShowPin });
              }}
              error={errorMessage || errors.promoCode}
            />
            <Button
              className={cn('rounded-l-none', buttonClassName)}
              type="submit"
              isSubmitting={isSubmitting}
              variation={buttonVariation}
            >
              {isSubmitting ? 'Saving...' : buttonText}
            </Button>
          </div>
          {showPin && (
            <FormField
              name="pin"
              label="Pin Number"
              inputClass="mt-6 w-60 bp2:w-96"
              labelClass="sr-only"
              placeholder="Enter Pin"
              maxLength={4}
            />
          )}
        </Form>
      )}
    </Formik>
  );
};

PromoCodeForm.propTypes = {
  errorMessage: PropTypes.string,
  handleAddVoucherClick: PropTypes.func.isRequired,
  buttonVariation: PropTypes.string,
  buttonClassName: PropTypes.string,
  formFieldClassName: PropTypes.string,
  buttonText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default PromoCodeForm;
